<template>
  <el-container style="height: 100vh; width: 100vw; background: #f0f2f5；overflow:hidden;">
    <template>
      <el-container>
        <el-header>
          <div class="header-left header-card">
            <div class="header-logo-platform">
              <img alt src="../assets/images/float/logo@2x.png" class="logo-wrapper" />
            </div>
            <!-- <el-dropdown @command="handleSelect" @visible-change="changeArrow" trigger="click">
              <div class="menu menu-ucon">
                <i class="iconfont menu-icon iconic_list_a"></i>
                <i :class="{ 'rotate-arrow': arrow }" class="iconfont down-icon iconicon_arrow02"></i>
              </div>
              <el-dropdown-menu class="dropdown-add" slot="dropdown">
                <el-dropdown-item
                  command="2-1"
                  style="display: flex; align-items: center; padding: 16px"
                  v-if="getAuthAgent && getAuthAgent.includes('2')"
                >
                  <img height="23" src="../assets/images/shop_en.png" v-if="language === 'en'" />
                  <img height="23" src="../assets/images/shop.png" v-else />
                </el-dropdown-item>
                <el-dropdown-item
                  command="2-2"
                  style="display: flex; align-items: center; padding: 16px"
                  v-if="getAuthAgent && getAuthAgent.includes('3')"
                >
                  <img height="23" src="../assets/images/bi.png" />
                </el-dropdown-item>
                <el-dropdown-item
                  command="2-3"
                  style="display: flex; align-items: center; padding: 16px"
                  v-if="getAuthAgent && getAuthAgent.includes('5')"
                >
                  <img height="23" src="../assets/images/ERP.png" />
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown> -->
            <div class="platform-list-wrapper">
              <div
                class="platform-list-wrapper__item"
                :class="{ active: headerMenuActive === '2-1' }"
                v-if="getAuthAgent && getAuthAgent.includes('2')"
                @click="handleSelect('2-1')"
              >
                <iconSvg
                  class="icon-info"
                  :iconClass="headerMenuActive === '2-1' ? 'icondianpufuwu-gaoliang' : 'icondianpufuwu-moren'"
                ></iconSvg>
                <span class="sys-name">{{ $t('system::common::店铺服务') }}</span>
              </div>
              <div
                class="platform-list-wrapper__item"
                :class="{ active: headerMenuActive === '2-2' }"
                v-if="getAuthAgent && getAuthAgent.includes('3')"
                @click="handleSelect('2-2')"
              >
                <iconSvg
                  class="icon-info"
                  :iconClass="headerMenuActive === '2-2' ? 'iconjingyingfenxi2-gaoliang' : 'iconjingyingfenxi-moren'"
                ></iconSvg>
                <span class="sys-name">{{ $t('system::common::经营分析') }}</span>
              </div>
              <div
                class="platform-list-wrapper__item"
                :class="{ active: headerMenuActive === '2-3' }"
                v-if="getAuthAgent && getAuthAgent.includes('5')"
                @click="handleSelect('2-3')"
              >
                <iconSvg
                  class="icon-info"
                  :iconClass="headerMenuActive === '2-3' ? 'iconERP-gaoliang' : 'iconERP-moren'"
                ></iconSvg>

                <span class="sys-name">{{ $t('system::common::ERP系统') }}</span>
              </div>
            </div>
          </div>
          <div class="header-right header-card">
            <span class="timeArea">(GMT+08:00) 北京</span>

            <div class="icon-item__wrap">
              <div class="icon-item" @click="handlePreviewLink('docs')">
                <i class="icon-svg iconfont iconbangzhuzhongxin"></i>
                帮助
              </div>
              <div class="icon-item" @mouseenter="messageShow = true" @mouseleave="messageShow = false">
                <i class="icon-svg iconfont iconxiaoxi1"></i>
                消息
                <span class="unread-num one-line" v-if="unread > 0">{{ unread > 99 ? '99+' : unread }}</span>
                <transition name="fade-in-linear">
                  <Message class="message-popop" v-show="messageShow"></Message>
                </transition>
              </div>
              <div class="icon-item" @click="openKefu">
                <i class="icon-svg iconfont iconkefu"></i>
                客服
              </div>
            </div>
            <el-dropdown
              @command="onselectMerchantId"
              @visible-change="showDropdown"
              class="index--merchantSelect"
              v-if="merchantShopOptions.length > 1 || preAccount"
            >
              <span>
                <i class="icon-svg iconfont iconqiye1 icon-qiye"></i>
              </span>
              <el-dropdown-menu class="index--merchantSelect__menu" slot="dropdown">
                <div class="index--merchantSelect__menuTitle">
                  <span>
                    <img src="../assets/images/icon-qiye.png" />
                    {{ $t('user-guidance::data::my_company') }}
                    <!-- {{ $t('user-guidance::data::count', { data: merchantShopOptions.length }) }} -->
                  </span>
                  <span style="color: #999">
                    <i @click="$router.push('/enterprise-manager')" class="iconfont icona-15shezhi"></i>
                  </span>
                </div>
                <el-dropdown-item
                  :command="item.userId"
                  :key="item.userId"
                  :style="merchantId === item.userId ? 'color: #0560fd' : ''"
                  class="index--merchantSelect__menuItem"
                  v-for="item in merchantShopOptions.filter(item => item.isDisplay)"
                >
                  <span class="index--merchantSelect__itemName">{{ item.userName }}</span>
                  <i class="el-icon-check" v-if="merchantId === item.userId"></i>
                  <el-badge :max="99" :value="item.messageNum" class="badge" v-else-if="item.messageNum" />
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <img class="user-icon" src="../assets/images/icon_head@2x.png" />
            <el-dropdown :show-timeout="0" @command="handleCommand">
              <div class="user-container">
                <icon-svg class="down-icon" iconClass="icona-10xiala1"></icon-svg>
              </div>
              <el-dropdown-menu slot="dropdown" style="padding: 22px 0 15px" class="custom-dropdown">
                <div class="drop-wrap">
                  <img class="account-icon" src="../assets/images/icon_head@2x.png" />
                  <div class="account-wrap">
                    <p class="login-name one-line">{{ userInfo.loginName }}</p>
                    <p class="phone" v-if="userInfo.phone && userInfo.phone !== userInfo.loginName">
                      {{ userInfo.phone }}
                    </p>
                  </div>
                </div>
                <el-dropdown-item command="personal">
                  <div class="edit-drop__item">
                    <icon-svg class="drop-icon" iconClass="icongerenzhongxin1"></icon-svg>
                    {{ $t('system::common::btn::个人中心') }}
                  </div>
                </el-dropdown-item>
                <!-- <el-dropdown-item command="language" v-auth="'language'">
                  {{ $t('system::common::btn::change_language') }}
                </el-dropdown-item> -->
                <el-dropdown-item command="changePwd">
                  <div class="edit-drop__item">
                    <icon-svg class="drop-icon" iconClass="iconmima"></icon-svg>
                    {{ $t('system::common::btn::修改密码') }}
                  </div>
                </el-dropdown-item>
                <el-dropdown-item command="logout">
                  <div class="edit-drop__item">
                    <icon-svg class="drop-icon" iconClass="icontuichu1"></icon-svg>
                    {{ $t('system::common::btn::logout') }}
                  </div>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </el-header>
        <template v-if="!changeMerchantIdVisible">
          <el-main class="content-js main-content-flex">
            <!-- 店铺绑定弹窗 -->
            <bindModal @close="closeBindModal" @show="showBindModal" v-model="bindShopModalShow"></bindModal>
            <welcomeModal @bindShop="showBindModal"></welcomeModal>
            <menu-side
              :param="{ only: false, list: ['contract-manager', 'account-manager', 'personal-message'] }"
              v-if="$route.name !== 'expired'"
            ></menu-side>
            <!-- tabs -->
            <div class="layout-main-content">
              <div class="tabs-headerBar" v-show="routerList.length">
                <div class="tab-bar-box">
                  <ul class="tab-bar">
                    <ScrollsBar style="padding-bottom: 9px" :vertical="false" ref="scroll">
                      <li
                        :class="{
                          'tab-bar-item': true,
                          active:
                            Object.keys(curTab.query).length &&
                            (curTab.name === 'data-board' || curTab.name === 'iframe-board')
                              ? curTab.fullPath === String(item.fullPath)
                              : curTab.name === item.name,
                        }"
                        :key="item.url"
                        @click="clickTab(item)"
                        v-for="item in routerList"
                      >
                        <span class="text">{{ item.uniName || item.meta.name || item.name }}</span>
                        <i @click.stop="removeTab(item)" class="el-icon-close"></i>
                      </li>
                    </ScrollsBar>
                  </ul>
                </div>
              </div>
              <!-- <div class="combo-tips" v-if="comboVisible && user.combo.isTrial && user.combo.isTrial === 1">
              <div class="flex-center">
                <i class="el-icon-warning"></i>
                <p>
                  {{
                    $t('personal::common::trial', { day: user.combo.comboExpireDay, date: user.combo.comboExpireDate })
                  }}
                </p>
                <a class="but-combo" @click="handleCommand('personal')">{{ $t('personal::common::立享优惠') }}</a>
              </div>
              <i class="el-icon-close" @click="comboVisible = false"></i>
              </div>-->
              <ScrollsBar class="custom-scroll-wrap" id="boardShowWrap" ref="boardShowWrap">
                <template>
                  <el-container
                    :class="[
                      'router-wrapper',
                      isCustomBi ? 'clearPadding' : '',
                      routerList.length ? '' : 'cell-nobig-padding',
                    ]"
                  >
                    <template v-if="noTitlePage">
                      <div>
                        <div @click="onBack" class="comm-back-wrap mb-16" ref="back" v-if="localBackName">
                          <i class="iconfont iconarrow-up"></i>
                          <span class="backText">
                            <!-- {{ `${$t('system::common::btn::back')} ${$t(`menu::${localBackName}`)}` }} -->
                            {{ $t('system::common::btn::back') }}
                          </span>
                        </div>
                        <!-- <div class="title-page mb-16" v-if="metaName">
                    {{ $t(`menu::${metaCode}`) || metaName }}
                        </div>-->
                      </div>
                    </template>
                    <!-- <span
                      :class="[menu.collapse ? 'fold ' : 'unfold']"
                      @click="toggleMenu"
                      class="menu-toggle-wrap"
                      v-if="
                        menu.menus &&
                        menu.menus.find(item => item.actionCode === 'shop-management') &&
                        menu.menus.find(item => item.actionCode === 'shop-management').children.length &&
                        $route.name !== 'expired'
                      "
                    > -->
                    <span
                      :class="[menu.collapse ? 'fold ' : 'unfold']"
                      @click="toggleMenu"
                      class="menu-toggle-wrap"
                      v-if="$route.name !== 'expired'"
                    >
                      <i class="menu-toggle iconfont icondown-circle-01"></i>
                    </span>
                    <template v-if="visiable">
                      <keep-alive>
                        <router-view :key="$route.name" class="router-box" v-if="$route.meta.keepAlive"></router-view>
                      </keep-alive>
                      <router-view class="router-box" v-if="!$route.meta.keepAlive"></router-view>
                    </template>
                  </el-container>
                </template>
              </ScrollsBar>
            </div>
          </el-main>
        </template>
        <template v-else>
          <div class="change-merchat-box">{{ $t('system::common::正在为您切换主体') }}..</div>
        </template>
      </el-container>

      <el-dialog :append-to-body="true" :close-on-click-modal="false" :visible.sync="showLanguage" width="500px">
        <span slot="title">{{ $t('system::common::btn::change_system_language') }}</span>
        <div class="language-dialog">
          <div>
            <p>{{ $t('system::common::btn::select_change_language_holder') }}</p>
            <el-select
              :placeholder="$t('system::common::select_placeholder')"
              style="width: 250px; margin: 10px 0px"
              v-model="language"
            >
              <el-option :key="item.value" :label="item.label" :value="item.value" v-for="item in options"></el-option>
            </el-select>
          </div>
          <div class="dialog-footer" slot="footer">
            <el-button @click="showLanguage = false">{{ $t('system::common::btn::cancel') }}</el-button>
            <el-button @click="changeLanguage" type="primary">
              {{ $t('system::common::btn::confirm') }}
            </el-button>
          </div>
        </div>
      </el-dialog>
      <changePwdDialog v-model="showChangePwd"></changePwdDialog>
    </template>
  </el-container>
</template>
<script>
import MenuSide from './components/menu-side.vue'
import { hidePopper, toPersonalPage } from '@/utils/index.js'
import { mapState } from 'vuex'
import { logout } from '@/server/login'
import { Container, Header, Main, Dropdown, DropdownMenu, DropdownItem } from 'zz-element-ui'
import { clearAllCookie, redictToLogin } from '@/utils/index'
import { generalPageName } from '@/utils/dict'
import Cookies from 'js-cookie'
import { getSession, clearStorageExcept, _local } from '@/utils/storage'
import bindModal from '@/views/user-guidance/components/bind-modal'
import welcomeModal from '@/views/user-guidance/components/welcome-modal'
import Notice from './components/notice.vue'
import WaterMark from '@/utils/waterMark'
import { menuMap } from '@/lib/menuFormat'
import HeaderMenu from './components/header-menu.vue'
import changePwdDialog from './components/changePwdDialog.vue'
import { listToTree } from '@/utils/index'
import Message from '@/components/message.vue'
import { deepClone } from '@/utils'
import { getAuthorityMenu } from '@/server/common'
export default {
  components: {
    HeaderMenu,
    MenuSide,
    Message,
    welcomeModal,
    bindModal,
    Notice,
    'el-container': Container,
    'el-header': Header,
    'el-main': Main,
    'el-dropdown': Dropdown,
    'el-dropdown-menu': DropdownMenu,
    'el-dropdown-item': DropdownItem,
    changePwdDialog,
  },

  data() {
    return {
      merchantId: Number(this.$store.state.user.merchantId),
      isShowBindDialog: false,
      changeMerchantIdVisible: false,
      bindShopModalShow: false,
      arrow: false, // 判断列表是否展开
      showLanguage: false,
      showChangePwd: false, //修改密码弹框
      visiableTipMerchant: false,
      options: [
        { label: $t('system::common::chinese'), value: 'zh-CN' },
        { label: $t('system::common::english'), value: 'en' },
      ],
      language: Cookies.get('language'),
      isInTabs: true,
      interRes: null,
      messageShow: false,
      waterMark: null,
      needLayout: false,
      height: '100%',
      comboVisible: true,
      headerMenuActive: '2-2',
    }
  },
  computed: {
    userInfo() {
      return _local.get('userInfo') || {}
    },
    unread() {
      return (this.$store.state.headerMessage && this.$store.state.headerMessage.unread) || 0
    },
    getAuthAgent() {
      let list = _local.get('available_system_ids')
      return (list || '').split(',') || []
    },
    routerList() {
      return this.$store.state.menu.routerList
    },
    curTab() {
      return this.$store.state.menu.curTab
    },
    preAccount() {
      return Cookies.get('preAccount')
    },
    userName() {
      if (this.merchantShopOptions.find(item => item.userId === this.merchantId)) {
        return this.merchantShopOptions.find(item => item.userId === this.merchantId).userName
      }
      return _local.get('userName') || ''
    },
    visiable() {
      // return this.$store.state.pageVisable
      return true
    },
    merchantShopOptions() {
      return this.$store.state.user.merchantList
    },
    onLoadIframe() {
      return this.$store.state.user.onloadIframe
    },
    isCollGeneral() {
      return generalPageName.includes(this.$route.name)
    },
    ...mapState(['menu']),
    ...mapState(['user']),
    backName() {
      return this.$route.query.backName || (this.$route.meta && this.$route.meta.backName) || ''
    },
    noTitlePage() {
      return ![
        'default-board',
        'person-board',
        'user-guidance',
        'big-screen',
        'day-board',
        'market-board',
        'pearlgo-screen',
        'rl-day-board',
        'gl-day-board',
        'mw-day-board',
        'rl-screen',
        'gl-screen',
        'rl-market-board',
      ].includes(this.$route.name)
    },
    isCustomBi() {
      return ['default-board', 'person-board', 'data-board-main', 'person-board-main', 'screen-board'].includes(
        this.$route.name
      )
    },
    metaName() {
      return (
        (
          this.$store.state.user.authorityList.find(
            item => item.actionCode.split('::').length === 3 && item.actionCode.split('::').pop() === this.$route.name
          ) || {}
        ).actionName || undefined
      )
    },
    metaCode() {
      return (
        ((
          this.$store.state.user.authorityList.find(
            item => item.actionCode.split('::').length === 3 && item.actionCode.split('::').pop() === this.$route.name
          ) || {}
        ).actionCode &&
          (
            this.$store.state.user.authorityList.find(
              item => item.actionCode.split('::').length === 3 && item.actionCode.split('::').pop() === this.$route.name
            ) || {}
          ).actionCode
            .split('::')
            .slice(1)
            .join('::')) ||
        undefined
      )
    },
    localBackName() {
      return (
        ((
          this.$store.state.user.authorityList.find(
            item => item.actionCode.split('::').pop() === this.$route.meta.backName
          ) || {}
        ).actionCode &&
          (
            this.$store.state.user.authorityList.find(
              item => item.actionCode.split('::').pop() === this.$route.meta.backName
            ) || {}
          ).actionCode
            .split('::')
            .slice(1)
            .join('::')) ||
        undefined
      )
    },
    headerMenus() {
      const parent = this.menu.menus.find(item => item.actionCode === 'shop-management' && item.actionType === 1)
      const menu =
        parent && parent.children
          ? parent.children.filter(
              el => el.actionCode.includes('system-setting') || el.actionCode.includes('work-data')
            )
          : []
      return menu
    },
    // metaName() {
    //   return this.$route.meta && this.$route.meta.name
    // }
  },
  watch: {
    $route: {
      handler: function (val) {
        try {
          // if (this.waterMark) {
          //   this.waterMark = null
          // }
          // if (this.$preAccount) {
          // this.$nextTick(() => {
          // this.interRes = setInterval(() => {
          if (
            (document.getElementById('boardShowWrap') && window && window.top === window.self) ||
            this.$store.state.isAllScreen
          ) {
            if (this.waterMark) {
              // for (let el of document.querySelectorAll('.water-mark-container')) {
              //   el.remove()
              // }
              // this.waterMark = new WaterMark(document.getElementById('boardShowWrap'), {
              //   text: this.$store.state.user.userName,
              //   color: '#666',
              //   opacity: 0.1
              // })
              if (!val.meta.notLayout || !this.user.watermark.status) {
                if (this.waterMark) {
                  this.waterMark.hide()
                  console.log('hide')
                }
              } else {
                if (this.waterMark) {
                  this.waterMark.show()
                  console.log('show')
                }
              }
            }
          }
          // }, 500)
          // })
          // }
        } catch (e) {
          console.log('watermark error:', e)
        }
      },
      immediate: true,
    },
    '$store.state.bindShopModalShow'(bool) {
      this.bindShopModalShow = bool
    },
    'user.watermark': {
      handler(val) {
        if (!!val.status) {
          if (this.waterMark) {
            this.waterMark.refresh(val)
            if (!this.$route.meta.notLayout || !this.user.watermark.status) {
              this.waterMark.hide()
              console.log('hide')
            }
          }
        } else {
          if (this.waterMark) {
            this.waterMark.hide()
          }
        }
      },
      deep: true,
    },
  },
  async mounted() {
    await this.$store.dispatch('getBoardList')
    this.onTimmerMerchantId()
    window.addEventListener('message', event => {
      if (event && event.data && String(event.data).indexOf('bi::') >= 0) {
        const [main, status, data] = String(event.data).split('::')
        if (status == '401') {
          this.handleCommand('logout')
          // this.$router.replace('/expired')
          // if (!this.$store.state.user.isExpired) {
          //   this.$router.replace('/expired')
          // }
          // this.$store.commit('user.setIsExpired', true)
        } else if (['403', '400', '500', '0', 'error'].includes(status)) {
          this.$message.error(data == 'undefined' ? this.$t('system::error::serve') : data)
        }
      }
    })
    await this.$store.dispatch('getWatermark')
    this.initWatermark()
    const that = this
    window.addEventListener('resize', event => {
      for (let el of document.querySelectorAll('#boardShowWrap .water-mark-container')) {
        el.remove()
      }
      that.initWatermark()
    })
  },
  methods: {
    openKefu() {
      const kefu = document.getElementById('div_company_mini')
      const miniBtn = document.getElementById('mini-btn')
      if (this.timer) clearInterval(this.timer)
      if (miniBtn && document.getElementById('iframe_company_mini').getAttribute('src')) {
        kefu.style.display = 'block'
        miniBtn.onclick()
      } else {
        this.timer = setInterval(() => {
          const newKefu = document.getElementById('div_company_mini')
          const newMiniBtn = document.getElementById('mini-btn')
          if (newMiniBtn && document.getElementById('iframe_company_mini').getAttribute('src')) {
            clearInterval(this.timer)
            newKefu.style.display = 'block'
            newMiniBtn.onclick()
          }
        }, 500)
      }
    },
    async init(callback) {
      await this.$store.dispatch('getCombo')
      const res = await getAuthorityMenu(_local.get('merchantId'))
      if (res.data.code === 0) {
        const menu = menuMap(res.data.data)
        _local.set('AuthList', res.data.data)
        this.$store.commit('user.setAuthorityList', menu)
        this.$store.commit('menu.setMenus', listToTree(deepClone(menu)))
      }
      await this.$store.dispatch('getBindData')
      await this.$store.dispatch('getBoardList', { update: true })
      await this.$store.dispatch('getWatermark')

      callback && callback()
    },
    initWatermark() {
      this.$nextTick(() => {
        this.waterMark = new WaterMark(document.getElementById('boardShowWrap'), this.user.watermark)
        if (!this.$route.meta.notLayout || !this.user.watermark.status) {
          this.waterMark.hide()
          console.log('hide')
        }
      })
    },
    showDropdown(val) {
      if (val) {
        // 定位到当前商家项
        this.$nextTick(() => {
          let a = this.merchantShopOptions.findIndex(el => el.userId === this.merchantId)
          if (a >= 3) {
            let element = document.getElementsByClassName('index--merchantSelect__menu')
            element[0].scrollTo(0, (a - 3) * 64 + 32)
          }
        })
      }
    },
    hidePopper,
    onTimmerMerchantId() {
      const timmer = setInterval(() => {
        if (_local.get('merchantId') && _local.get('merchantId') != this.$store.state.user.merchantId) {
          // if (!this.visiableTipMerchant) {
          //   this.visiableTipMerchant = true
          //   clearInterval(timmer)
          //   this.$alert(
          //     this.$t('system::common::merchant-tip'),
          //     this.$t('system::common::dialog::change_merchant_tooltip'),
          //     {
          //       confirmButtonText: this.$t('system::common::ok'),
          //       callback: action => {
          //         window.location.replace('/')
          //       }
          //     }
          //   )
          // }
          window.location.replace('/')
        }
      }, 2000)
    },
    async onselectMerchantId(val) {
      // this.$msgbox({
      //   title: this.$t('system::common::dialog::change_merchant_tooltip'),
      //   confirmButtonText: this.$t('system::common::btn::confirm'),
      //   cancelButtonText: this.$t('system::common::btn::cancel'),
      //   showCancelButton: true,
      //   message: this.$t('system::common::dialog::change_merchant_tooltip_message', {
      //     userName: this.merchantShopOptions.find(item => item.userId === val).userName
      //   })
      // }).then(action => {

      // this.merchantId = val
      // const url = window.location.origin
      // if (url.indexOf('?') >= 0) {
      //   window.location.href = `${url}&merchantId=${val}`
      // } else {
      //   window.location.href = `${url}?merchantId=${val}`
      // }

      // })
      this.changeMerchantIdVisible = true
      this.$router.push({ path: '/' })
      this.merchantId = val

      const host = window.location.hostname
      const cache = 7
      // if (this.merchantId == 100) {
      //   this.$preAccount = 2
      //   Cookies.set('preAccount', 2, { domain: host, expires: cache })
      // } else {
      //   this.$preAccount = 1
      //   Cookies.set('preAccount', 1, { domain: host, expires: cache })
      // }
      this.$store.commit('user.setMerchantId', this.merchantId)
      // 切换商家时清除缓存路由
      this.$store.commit('setCurTab', '')
      this.$store.commit('clearRouterList')
      this.init(() => {
        this.changeMerchantIdVisible = false
        this.initWatermark()
        // this.$router.push({ path: '/' })
      })
    },
    handlePreviewLink(type) {
      window.open(process.env.VUE_APP_HELP, '_blank')
    },
    onBack() {
      // if (this.$route.meta && this.$route.meta.backName) {
      //   this.$router.push({ name: this.$route.meta.backName })
      // } else {
      //   this.$router.go(-1)
      // }
      this.$router.go(-1)
    },
    handleSelect(target) {
      let url = ''
      switch (target) {
        case '2-1':
          Cookies.set('systemId', '2', { domain: process.env.VUE_APP_DOMAIN, expires: 7 })
          this.$store.dispatch('buried', { event: 'ClickPlatformChange', bPlatform: 'BI', toPlatform: 'shoplus' })

          let url = `${_local.get('BITOSHOPLINK') || process.env.VUE_APP_SHOP_URL}`
          if (Cookies.get('preAccount')) {
            url =
              url +
              `?name=${this.$store.state.user.userName}&preAccount=${Cookies.get('preAccount')}&userId=${
                this.$store.state.user.userId
              }`
          }
          window.location.href = url
          break
        case '2-2':
          break
        case '2-3':
          Cookies.set('systemId', '5', { domain: process.env.VUE_APP_DOMAIN, expires: 7 })
          this.$store.dispatch('buried', { event: 'ClickPlatformChange', bPlatform: 'ERP', toPlatform: 'shoplus' })
          const { userName, userId, merchantId } = this.$store.state.user
          _local.set('merchantId', '')
          url =
            process.env.VUE_APP_ERP_URL +
            `?token=${Cookies.get('saasToken')}&name=${userName}&userId=${userId}&merchantId=${merchantId}`
          if (Cookies.get('preAccount')) {
            url = url + `&preAccount=${Cookies.get('preAccount')}`
          }
          setTimeout(() => {
            window.location.href = url
          }, 500)
          break
        default:
          break
      }
    },
    toggleMenu() {
      this.$store.commit('menu.setCollapse', !this.$store.state.menu.collapse)
    },
    async handleCommand(value) {
      if (value === 'logout') {
        Cookies.remove('domain', { domain: process.env.VUE_APP_DOMAIN, expires: 0 })
        if (this.$demo) {
          window.location.href = process.env.VUE_APP_LOGINURL
          return
        }
        const preAccount = Cookies.get('preAccount')
        await logout()
        // localStorage.clear()
        // clearStorageExcept()
        sessionStorage.clear()
        clearAllCookie('userId')
        // this.$router.replace({ path: '/login' })
        Cookies.set('systemId', this.$systemId, { domain: process.env.VUE_APP_DOMAIN, expires: 7 })
        redictToLogin(preAccount)
        // window.location.href = url
      } else if (value === 'language') {
        this.showLanguage = true
      } else if (value === 'changePwd') {
        this.showChangePwd = true
      } else if (value === 'personal') {
        // _local.set('backUrl', this.$route.name === 'expired' ? window.location.origin : window.location.href)
        // this.$router.push(this.$preAccount ? '/my-account' : '/open-contract')
        toPersonalPage()
      }
    },
    changeLanguage() {
      if (getSession('language') === this.language) {
        this.showLanguage = false
        return
      }
      this.$store.commit('changeLanguage', this.language)
      window.location.reload()
      this.showLanguage = false
    },
    // 箭头动画
    changeArrow(type) {
      this.arrow = type
    },
    closeBindModal() {
      this.$store.commit('setShopVisiable', { visiable: false })
      this.bindShopModalShow = false
    },
    showBindModal() {
      this.$store.commit('setShopVisiable', { visiable: true })
      this.bindShopModalShow = true
    },
    clickTab(item) {
      if (this.curTab.name === 'data-board' || this.curTab.name === 'iframe-board') {
        if (this.curTab.fullPath != String(item.fullPath)) {
          this.$router.push(item.fullPath)
        }
      } else if (this.curTab.name != item.name) {
        this.$router.push(item.fullPath)
      }
    },
    removeTab(item) {
      if (item.fullPath === this.curTab.fullPath) {
        let index = this.routerList.findIndex(el => el.fullPath === this.curTab.fullPath)
        if (this.routerList.length === 1) {
          this.$router.push('/index')
        } else {
          this.$router.push(index > 0 ? this.routerList[index - 1].fullPath : this.routerList[index + 1].fullPath)
        }
      }
      this.$refs.boardShowWrap.scrollToTop()
      this.$store.commit('removeRouter', item)
    },
  },
}
</script>
<style lang="scss">
.layout-main-content {
  position: relative;
  flex: 1;
  overflow: hidden;
}
.index--merchantSelect {
  cursor: pointer;

  // padding: 0 24px;
  // border-left: 1px solid #dddddd;
  // border-right: 1px solid #dddddd;
  &__menuTitle {
    height: 54px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 24px;
    font-size: 12px;
    font-family: MicrosoftYaHei;
    color: #666666;
    line-height: 12px;
    border-bottom: 1px solid #edeff2;
    position: fixed;
    z-index: 999;
    background: #fff;
    width: 251px;
    img {
      vertical-align: sub;
      margin-right: 8px;
    }
    .icona-15shezhi {
      font-size: 20px;
      cursor: pointer;
    }
  }
  &__menu {
    padding: 0;
    top: 52px !important;
    max-height: 280px;
  }
  &__menuItem {
    width: 260px;
    border-bottom: 1px solid #edeff2;
    height: 63px;
    font-size: 14px;
    color: #010517;
    line-height: 14px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    &:first-of-type {
      margin-top: 55px;
    }
  }
  &__itemName {
    width: 190px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    line-height: 24px;
  }
}
</style>

<style lang="scss" scoped>
@import '../assets/style/header.scss';
.change-merchat-box {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.icon-qiye {
  margin-left: 24px;
  font-size: 20px;
  color: rgba(255, 255, 255, 0.65);
  &:hover {
    color: rgba(255, 255, 255, 0.85);
  }
}
.combo-tips {
  position: absolute;
  top: 40px;
  left: 50%;
  width: 580px;
  margin-left: -290px;
  background: #ffffff;
  box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 13px 16px;
  box-sizing: border-box;
  z-index: 10;
  .el-icon-warning {
    font-size: 18px;
    color: #0560fd;
    margin-right: 8px;
  }
  .but-combo {
    color: #ff4d00;
    text-decoration: underline;
    margin-left: 8px;
  }
  .el-icon-close {
    margin-left: 24px;
    color: #999;
    font-size: 16px;
    cursor: pointer;
  }
}
::v-deep {
  .custom-scroll-wrap {
    & > .el-scrollbar__bar {
      &.is-horizontal,
      &.is-vertical {
        z-index: 10 !important;
      }
      z-index: 10 !important;
    }
  }
}
.iconHelp {
  vertical-align: middle;
  font-size: 26px;
  color: #fff;
}

.merchant-content {
  width: 200px;
}
.user-container {
  .xiala {
    width: 14px;
    height: 14px;
  }
  .iconfont {
    font-size: 14px;
  }
}
.comm-back-wrap {
  width: 150px;
  cursor: pointer;
  i {
    color: $--text-66;
    font-size: 12px;
    margin-right: 4px;
    opacity: 0.5;
  }
  .backText {
    font-size: 12px;
    color: #010517;
    line-height: 16px;
  }
}
.title-page {
  font-size: 20px;
  font-weight: bold;
  color: $--text-26;
}

.user-tip {
  margin-left: 50px;
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #323232;
  .link {
    margin-left: 10px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #ff4c00;
  }
}
.main-content-flex {
  display: flex;
  flex: 1;
  flex-basis: auto;
  box-sizing: border-box;
  .router-wrapper {
    overflow: auto;
    flex-direction: column;
    position: relative;
    box-sizing: border-box;
    padding: 24px;
    padding-top: 60px;
    &.clearPadding {
      padding: 0;
      margin-top: 36px;
    }
    &.cell-nobig-padding {
      padding-top: 24px;
    }
    &.iScreen {
      padding: 36px 0 0 0;
    }
  }
  .router-box {
    box-sizing: border-box;
    width: 100%;
  }
}
// ::v-deep .el-progress-bar {
//   .el-progress-bar__outer {
//     background-color: transparent;
//   }
// }
.back-btn {
  margin-bottom: 16px;
  cursor: inherit !important;
  .el-page-header__left {
    cursor: pointer;
  }
}
.menu-ucon {
  border-left: 1px solid #dddddd;
  padding-left: 12px;
  cursor: pointer;
  margin-left: 12px;
  .menu-icon {
    font-size: 16px;
    color: #010517;
  }
  .down-icon {
    margin-left: 10px;
    display: inline-block;
    font-size: 16px;
  }
}
// 折叠按钮
.collapse-btn {
  position: absolute;
  width: 22px;
  height: 60px;
  top: 50%;
  left: 260px;
  margin-top: -30px;
  background: #ffffff;
  box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.18);
  border-radius: 0px 6px 6px 0px;
  z-index: 10;
  cursor: pointer;
  i {
    position: absolute;
    width: 24px;
    height: 24px;
    line-height: 24px;
    text-align: center;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}

::v-deep .el-menu-header-card {
  border-bottom: none !important;
  .el-submenu__icon-arrow {
    display: none;
  }
  .is-opened {
    .down-icon {
      transform: rotate(180deg);
    }
  }
  .el-submenu__title {
    border-bottom: none !important;
  }
}
.menu {
  border-left: 1px solid #dddddd;
  padding-left: 12px;
  cursor: pointer;
  margin-left: 12px;
  color: #010517;
  img {
    width: 96px;
    height: 23px;
  }
}
::v-deep .el-breadcrumb {
  flex: 1;
}
::v-deep .el-main {
  overflow: hidden;
  background: $--background-color-base;
  padding: 0;
}
.back-btn {
  font-size: 20px;
  margin-right: 16px;
  cursor: pointer;
}
.top-text {
  width: auto;
  height: 25px;
  font-size: 18px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #3b406f;
  line-height: 25px;
}
.menu-toggle-wrap {
  position: fixed;
  top: 50vh;
  left: 0;
  z-index: 9;
  font-size: 12px;
  width: 12px;
  display: flex;
  align-items: center;
  border-radius: 0px 13px 13px 0px;
  border: 1px solid #e2e3e5;
  border-left: 0px solid #e2e3e5;
  height: 48px;
  background: #fafbff;
  .menu-toggle {
    font-size: 12px;
    color: #666666;
    transition: transform 0.3s;
    cursor: pointer;
  }
  &.fold {
    .menu-toggle {
      transform: rotate(270deg);
    }
    left: 88px;
  }
  &.unfold {
    .menu-toggle {
      transform: rotate(90deg);
    }
    left: 220px;
  }
}

.user-icon {
  margin-left: 24px;
  width: 36px;
  height: 36px;
}
.user-name {
  color: #fff;
  font-size: 12px;
  margin-left: 10px;
}
::v-deep.dropdown-add.el-dropdown-menu .el-dropdown-menu__item {
  text-align: left;
  line-height: 0;
  padding: 16px;
}
::v-deep.dropdown-add.el-dropdown-menu {
  margin: 0;
  padding: 0;
}
.rotate-arrow {
  display: inline-block;
  transform: rotate(180deg);
  -webkit-transform: rotate(180deg);
}
.dialog-footer {
  display: flex;
  justify-content: flex-end;
}
.badge {
  /deep/ sup {
    top: 0;
  }
  /deep/ {
    .el-badge__content {
      background: #bbb;
      height: 16px;
      line-height: 16px;
    }
  }
}

.tabs-headerBar {
  box-sizing: border-box;
  left: 0;
  top: 0;
  width: 100%;
  border-top: 1px solid #e2e3e5;
  // height: 120px;
  background-color: #fff;
  position: absolute;
  z-index: 301;
  border-left: 1px solid #f0f2f5;
  > .tab-bar-box {
    // overflow: auto;
    // overflow-y: hidden;
    -ms-overflow-style: none;
    overflow: -moz-scrollbars-none;

    &::-webkit-scrollbar {
      width: 0 !important;
    }
    .tab-bar {
      // minwidth: 200%;
      box-sizing: border-box;
      line-height: 36px;
      height: 36px;
      border-bottom: 1px solid #f0f2f5;
      // float: left;
      // display: flex;
      white-space: nowrap;
      flex-wrap: nowrap;
      -ms-overflow-style: none;
      overflow: -moz-scrollbars-none;

      &::-webkit-scrollbar {
        width: 0 !important;
      }
      .tab-bar-item {
        white-space: nowrap;
        display: inline-block;
        line-height: 32px;
        font-size: 12px;
        padding: 0 12px;
        border-right: 1px solid #f0f2f5;
        cursor: pointer;
        transition: 0.4s all ease;
        &:hover {
          color: #0560fd !important;
        }
        .text {
          margin-right: 8px;
        }
      }
      .active {
        color: #0560fd !important;
      }
    }
  }
  .header-bar-content {
    // line-height: 64px;
    padding: 0 24px;
    .header-bar-content-title {
      line-height: 48px;
    }
  }
}
.header-menu + .header-menu {
  margin-left: 16px;
}

.timeArea {
  font-size: 12px;
  font-weight: 400;
  margin-right: 8px;
  color: #fff;
  opacity: 0.7;
}
</style>
<style>
.help-tooltip {
  border: none !important;
  box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.25);
}
</style>
